

import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import style from './print.module.css';

const fontSize = '20px';
const borderTable = '1px solid black';

/**
 * این کامپوننت برای نمایش جدول فاکتور های پرینت است
 */
const Print = ({ data }) => {

    return (

        <Table style={{ direction: 'rtl', marginTop: '100px' }} className={style.TabbelPrint} >
            <tbody >
                <tr>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.subrowData} > مشتری </td>
                    <td style={{ fontSize: fontSize, border: borderTable }} colSpan='4' className={style.tdData} >
                        <Table >
                            <tbody>

                                <tr>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{data.customerName}</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>شماره تلفن :	 {data.tell}</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>شماره موبایل : {data.cellphone}</td>

                                </tr>
                                <tr>

                                    <td style={{ fontSize: fontSize, border: borderTable }} colSpan='4' >
                                        آدرس : {data.address}
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </td>

                </tr>
                <tr>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.subrowData}> سفارش </td>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.tdData}>
                        <Table >
                            <tbody className='borderTd'>
                                <tr>

                                    <td style={{ fontSize: fontSize, border: borderTable }}>کد پیگیری	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{data.trackingCode}</td>
                                </tr>
                                <tr>

                                    <td style={{ fontSize: fontSize, border: borderTable }}>نوع خدمات	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{`${data.groupName} ${data.periodTime} ساعت`}</td>
                                </tr>
                                <tr>

                                    <td style={{ fontSize: fontSize, border: borderTable }}>تاریخ و ساعت	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{data.persianStartWork}</td>
                                </tr>
                                <tr>

                                    <td style={{ fontSize: fontSize, border: borderTable }}>مدت زمان خدمت	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{`${data.periodTime} ساعت`}</td>
                                </tr>
                                <tr>

                                    <td style={{ fontSize: fontSize, border: borderTable }}>نحوه ی پرداخت	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{data.paymentTypeTitle}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </td>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.subrowData}> مشخصات </td>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.tdData}>

                        <Table  >
                            <thead>
                                <tr>
                                    <th style={{ fontSize: fontSize, border: borderTable }}>کد پرسنلی	</th>
                                    <th style={{ fontSize: fontSize, border: borderTable }}>نام نیرو	</th>
                                    <th style={{ fontSize: fontSize, border: borderTable }}>خدمات اضافه	</th>
                                    <th style={{ fontSize: fontSize, border: borderTable }}>هزینه</th>
                                </tr>
                            </thead>
                            <tbody >

                                {
                                    data.workerOrderSchedules.map(item => (
                                        <tr>
                                            <td style={{ fontSize: fontSize, border: borderTable }}>{item.personnelCode}</td>
                                            <td style={{ fontSize: fontSize, border: borderTable }}>{item.workerName}</td>
                                            <td style={{ fontSize: fontSize, border: borderTable }}>{item.orderGroupOptionTitles ? item.orderGroupOptionTitles.map(optin => <p>{optin}</p>) : null}</td>
                                            <td style={{ fontSize: fontSize, border: borderTable }}>{item.totalAmount}</td>
                                        </tr>
                                    ))
                                }



                            </tbody>
                        </Table>
                    </td>
                </tr>
                <tr>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.tdData} colSpan='2'> توضیحات : {data.description}</td>
                    <td style={{ fontSize: fontSize, border: borderTable }} className={style.tdData} colSpan='2' >
                        <Table  >
                            <tbody>
                                <tr>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>خدمات اضافه	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.additionalAmount)} ريال</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>هزینه سفارش	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.totalAmount - data.facilityAmounts)} ريال</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>تخفیف</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.discountAmount)} ريال</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>امکانات سفارش</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.facilityAmounts)} ريال</td>
                                </tr>
                                <tr>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>قابل پرداخت	</td>
                                    <td style={{ fontSize: fontSize, border: borderTable }}>{new Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 12 }).format(data.payableAmount)} ريال</td>
                                </tr>
                            </tbody>
                        </Table>
                    </td>
                </tr>
                {/* <tr>
                    <td colSpan='6' className='text-center pt-4 pb-2' >
                        <p>آدرس : میدان رسالت - ابتدای خیابان سمنگان-نبش کوچه ی حیدرآبادیان پلاک 84 طبقه ی 4 واحد 11</p>
                        <p>وب سایت : wwww.mojeno-co.com آدرس پست الکترونیکی : info@mojeno-co.com</p>
                    </td>
                </tr> */}
            </tbody>
        </Table>

    );
}

export default Print;
Print.propTypes = {
    /**داده است که در جدول نمایش داده میشود*/
    data: PropTypes.object,
};